<template>
    <section class="MediaMatrix_main">
        <section class="zjgzhjz_box">
            <h1>
                <img :src="require('@/common/images/other/icon1.png')" alt="">
                <span>公众号矩阵</span>
                <img :src="require('@/common/images/other/icon2.png')" alt="">
            </h1>
            <ul>
                <li v-for="(item, index) in listData1" :key="index">
                    <div class="font">
                        <div class="font_img">
                            <img :src="item.iconUrl" :alt="item.name">
                        </div>
                        <h2>{{item.name}}</h2>
                        <p>{{item.desc}}</p>
                    </div>
                    <div class="end">
                        <div class="end_img">
                            <img :src="item.QrCode" :alt="item.name">
                        </div>
                        <h2>{{item.name}}</h2>
                        <p>微信号：{{item.wxh}}</p>
                    </div>
                </li>
            </ul>
        </section>
        <section class="zjmtlm_box">
            <h1>
                <img :src="require('@/common/images/other/icon1.png')" alt="">
                <span>媒体联盟</span>
                <img :src="require('@/common/images/other/icon2.png')" alt="">
            </h1>
            <ul>
                <li v-for="(item, index) in listData2" :key="index">
                    <div class="font">
                        <div class="font_img">
                            <img :src="item.iconUrl" :alt="item.name">
                        </div>
                        <h2>{{item.name}}</h2>
                        <p>{{item.desc}}</p>
                    </div>
                    <div class="end">
                        <div class="end_img">
                            <img :src="item.iconUrl" :alt="item.name">
                        </div>
                        <h2>{{item.name}}</h2>
                        <div class="details">
                            <p @click="seeDetails(item.url)">查看详情<img :src="require('@/common/images/other/icon3.png')" alt=""></p>
                        </div>
                    </div>
                </li>
            </ul>
        </section>
    </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'templaet',
    data() {
        return {
            listData1: [
                {
                    name: '鲸融网',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zj.png',
                    desc: '鲸融网是全维度企业成长服务平台，专注于创业创新、商业管理与资本运营方向，提供新锐深度的商业报道。',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/zjdyh1.jpg',
                    wxh: 'zijingkeji'
                },
                {
                    name: '股鲸',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/gj.png',
                    desc: '在线股权激励专家，提供原创干货、热点资讯、数据报告、实战课程，从股权的视角看世界，与企业家共同成长！',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/gjdyh1.jpg',
                    wxh: 'gujing361'
                },
                {
                    name: 'IPO笔记',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/IPObj.png',
                    desc: '汇聚IPO领域最新资讯：最新上市企业情况、证监会政策、IPO排队情况等，我们是IPO最前沿，IPO领域的今日头条。',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/IPObj1.jpg',
                    wxh: 'IPObiji'
                },
                {
                    name: '董秘俱乐部',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/dmclub.jpg',
                    desc: '中国卓越的资本精英俱乐部，集聚优秀董秘及高管，互助成长，价值共享！',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/dmclub1.jpg',
                    wxh: 'hiyouib-dm'
                },
                {
                    name: '服务号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zj.png',
                    desc: '鲸融网是全维度企业成长服务平台，专注于创业创新、商业管理与资本运营方向，以活动、内容、知识、数据、工具及资源等赋能企业成长。',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/zjfwh1.jpg',
                    wxh: 'zijingfw'
                },
                {
                    name: '股鲸服务号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/gjfwh.png',
                    desc: '知识教育+投行服务，为广大企业主提供知识赋能等专业的股权投资服务。',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/gjfwh1.jpg',
                    wxh: 'zijing-2020'
                },
                {
                    name: '鲸融活动',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zjhd.png',
                    desc: '鲸活动优选创业创新、商业管理、资本运营方向的商业活动并进行深度赋能，为主办方提供活动全流程管理、用户数据管理、个性化推送等基础功能，并在获客赋能、内容赋能、工具赋能等特色服务上进行深度挖掘，助力中小企业数据化转型。',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/zjhd1.jpg',
                    wxh: 'Capwhale'
                },
                {
                    name: '鲸报告',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zjbg.png',
                    desc: '超过300个细分行业的精品研究报告供您查阅，课件、笔记、论文、文档等多种形式资料分享，打造商业人群共享的专业智库平台。',
                    QrCode: 'http://img.capwhale.com/capwhale/mpimage/jbgfwh1.jpg',
                    wxh: 'zjfw_888'
                }
            ],
            listData2: [
                {
                    name: '鲸融雪球号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/xueqiuhao.png',
                    desc: '聪明的投资者都在这里 - 3500万投资者都在用的投资社区,沪深港美全球市场实时行情,股票基金债券免费资讯,与投资高手实战交流。',
                    url: 'http://xueqiu.com/capwhale'
                },
                {
                    name: '鲸融搜狐号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/shouhuhao.png',
                    desc: '搜狐号是在搜狐门户改革背景下全新打造的分类内容的入驻、发布和分发全平台,是集中搜狐网、手机搜狐网和搜狐新闻客户端三端资源大力推广媒体和自媒体优质内容的平台。',
                    url: 'http://suo.im/6mfqjt'
                },
                {
                    name: '鲸融头条号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/toutiaohao.png',
                    desc: '致力于帮助企业、机构、媒体和自媒体在移动端获得更多曝光和关注，在移动互联网时代持续扩大影响力，同时实现品牌传播和内容变现。',
                    url: 'https://www.toutiao.com/c/user/55349778168/#mid=1559999917498369'
                },
                {
                    name: '鲸融雪球号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zj.png',
                    desc: '鲸融网是专注于创业创新、商业管理与资本运营方向，以内容、知识、活动、工具及资源整合等赋能企业成长的资本服务平台。',
                    url: 'http://xueqiu.com/capwhale'
                },
                {
                    name: '鲸融搜狐号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zj.png',
                    desc: '是专注于创业创新、商业管理与资本运营方向，以内容、知识、活动、工具及资源整合等赋能企业成长的资本服务平台。',
                    url: 'http://suo.im/6mfqjt'
                },
                {
                    name: '鲸融头条号',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zj.png',
                    desc: '鲸融网是专注于创业创新、商业管理与资本运营方向，以内容、知识、活动、工具及资源整合等赋能企业成长的资本服务平台。',
                    url: 'https://www.toutiao.com/c/user/55349778168/#mid=1559999917498369'
                },
                {
                    name: '鲸融看点',
                    iconUrl: 'http://img.capwhale.com/capwhale/matriaxicon/zj.png',
                    desc: '鲸融网是专注于创业创新、商业管理与资本运营方向，以内容、知识、活动、工具及资源整合等赋能企业成长的资本服务平台。',
                    url: 'https://cj.sina.com.cn/k/article/author_article/7128888640'
                }
            ]
        }
    },
    mounted() {},
    methods: {
        seeDetails(url) {
            window.open(url)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MediaMatrix_main {
    width: 1200px;
    margin: 0 auto;
    .zjgzhjz_box, .zjmtlm_box {
        &>h1{
            padding: 60px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            // background-color: pink;
            img {
                width: 26px;
                height: 30px;
            }
            span {
                font-size:24px;
                font-weight: bold;
                line-height:34px;
                margin: 0 18px;
            }
        }
        &>ul {
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-between;
            overflow: hidden;
            li {
                margin-right: 20px;
                margin-top: 40px;
                width: 285px;
                height: 368px;
                position: relative;
                perspective: 2500px;
                border-radius:6px;
                .font {
                    background: #fff;
                    -webkit-backface-visibility: hidden;
                    backface-visibility: hidden;
                    transition: 1s;
                    padding: 20px;
                    box-sizing: border-box;
                    .font_img {
                        margin: 20px auto auto;
                        height: 100px;
                        width: 100px;
                        border: 1px solid #f6f6f6;
                        border-radius: 50%;
                        overflow: hidden;
                        img {
                            height: 100px;
                            width: 100px;
                            max-width: 100%!important;
                            box-shadow:0px 0px 1px 0px rgba(0,0,0,0.3);
                        }
                    }
                    h2 {
                        margin-top: 24px;
                        margin-bottom: 7px;
                        font-size: 18px;
                        color: #333;
                        text-align: center;
                        line-height: 25px;
                        font-weight: 700;
                    }
                    p {
                        font-size: 14px;
                        color: #666;
                        line-height: 24px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-height: 120px;
                        border-bottom: none;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                        text-align: center;
                    }
                }
                .end {
                    transform: rotateY(-180deg);
                    -webkit-backface-visibility: hidden;
                    backface-visibility: hidden;
                    transition: 1s;
                    background: url('../../common/images/other/MediaMatrix_bg.png') 0 0 no-repeat;
                    background-size: 100% 100%;
                    .end_img {
                        width: 160px;
                        min-width: 160px;
                        height: 160px;
                        margin: 40px auto 30px;
                        padding: 13px;
                        border: 1px solid #FFF;
                        border-radius:6px;
                        img {
                            height: 160px;
                            width: 160px;
                            max-width: 100%!important;
                        }
                    }
                    h2 {
                        font-size: 18px;
                        color: #333;
                        line-height: 25px;
                        text-align: center;
                        font-weight: 700;
                    }
                    p {
                        text-align: center;
                        margin-top: 6px;
                        font-size: 14px;
                        color: #333;
                        line-height: 20px;
                    }
                    .details {
                        display: flex;
                        justify-content: center;
                        &>p {
                            margin-top: 20px;
                            color: #fff;
                            cursor: pointer;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            img {
                                width: 14px;
                                height: 10px;
                                margin-left: 8px;
                            }
                        }
                    }
                }
                .font, .end {
                    border-radius:6px;
                    width: 100%;
                    // width: 285px;
                    height: 100%;
                    // height: 368px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }
            li:nth-of-type(4n) {
                margin-right: 0;
            }
            li:nth-of-type(1), li:nth-of-type(2), li:nth-of-type(3), li:nth-of-type(4) {
                margin-top: 0;
            }
            li:hover .font {
                transform: rotateY(180deg);
            }
            li:hover .end {
                transform: rotateY(0deg);
            }
        }
    }
}
</style>